import { render, staticRenderFns } from "./AccumulationRateConfig.vue?vue&type=template&id=65154590&"
import script from "./AccumulationRateConfig.vue?vue&type=script&lang=ts&"
export * from "./AccumulationRateConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports